var React = require('react');

function Officiant (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M234.82,223.9a98.68,98.68,0,1,1-98.68-98.67A98.68,98.68,0,0,1,234.82,223.9Zm-98.68-81.42a81.43,81.43,0,1,0,81.43,81.42A81.42,81.42,0,0,0,136.14,142.48Z","key":0}),React.createElement("path",{"d":"M276.43,125.83h.25L306,93.64,286.62,72H244.49L225.15,93.64l29.29,32.19h.24a98.68,98.68,0,1,0,21.75,0Zm-12.38-11.17L246.56,94.72,255.13,85H276l8.57,9.71-17.5,19.94m-1.5,190.67A81.43,81.43,0,1,1,347,223.9,81.43,81.43,0,0,1,265.56,305.33Z","key":1})]);
}

Officiant.defaultProps = {"viewBox":"0 0 407.67 407.67"};

module.exports = Officiant;

Officiant.default = Officiant;
